var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuzl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo Icons"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Box",
    cx: 16.5,
    cy: 16.04,
    r: 16,
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 427318775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427318774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8158 23.5789V5.15381L10.0509 4.6416C6.79895 5.94708 4.5 9.12329 4.5 12.842V19.1578C4.5 24.0412 8.45874 27.9999 13.3421 27.9999H19.6579C22.6402 27.9999 25.2682 26.517 26.8686 24.254V23.5789H10.8158Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.6616 4H13.3458C12.1805 4 11.0715 4.23116 10.0528 4.64042C7.9477 6.68421 6.39844 10.0177 6.39844 12.8421C6.39844 17.1185 6.9896 19.6221 8.74286 22.0676C8.87928 22.2577 8.96833 22.48 8.98033 22.7131C9.00749 23.2404 8.89886 24.2067 7.94833 25.0764C7.84602 25.1699 7.91107 25.3411 8.04939 25.3467C8.64433 25.3726 9.84496 25.3379 11.0791 24.7928C11.4309 24.6375 11.8313 24.6646 12.1711 24.8453C14.2635 25.9562 16.714 26.1053 19.03 26.1053C21.9833 26.1053 24.9283 25.4484 26.8723 24.2636C27.8961 22.8204 28.5037 21.0615 28.5037 19.1579V12.8421C28.5037 7.95874 24.545 4 19.6616 4Z",
    fill: "#3763D3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 427318773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.5559 17.8941C23.2504 17.8941 22.1875 16.8311 22.1875 15.5256C22.1875 14.2202 23.2504 13.1572 24.5559 13.1572C25.8614 13.1572 26.9243 14.2202 26.9243 15.5256C26.9243 16.8311 25.8614 17.8941 24.5559 17.8941ZM24.5559 14.1046C23.7728 14.1046 23.1349 14.7425 23.1349 15.5256C23.1349 16.3088 23.7728 16.9467 24.5559 16.9467C25.3391 16.9467 25.977 16.3088 25.977 15.5256C25.977 14.7425 25.3391 14.1046 24.5559 14.1046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.2442 17.8942H20.6127C20.4383 17.8942 20.2969 17.7527 20.2969 17.5784V12.21H21.2442V17.8942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.3988 13.3151V13.6429C18.0016 13.3423 17.5127 13.1572 16.9778 13.1572C15.6723 13.1572 14.6094 14.2202 14.6094 15.5256C14.6094 16.8311 15.6723 17.8941 16.9778 17.8941C17.5127 17.8941 18.0016 17.709 18.3988 17.4084V17.5783C18.3988 17.7526 18.5403 17.8941 18.7146 17.8941H19.3462V13.3151H18.3988ZM16.9778 16.9467C16.1946 16.9467 15.5567 16.3088 15.5567 15.5256C15.5567 14.7425 16.1946 14.1046 16.9778 14.1046C17.761 14.1046 18.3988 14.7425 18.3988 15.5256C18.3988 16.3088 17.761 16.9467 16.9778 16.9467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.7669 12.21H9.71423V13.1573H13.0749L9.55633 17.2626H9.57275C9.46981 17.3959 9.39844 17.555 9.39844 17.7363V17.8942H14.1353C14.3096 17.8942 14.4511 17.7527 14.4511 17.5784V16.9468H11.0904L14.609 12.8415H14.5925C14.6955 12.7083 14.7669 12.5491 14.7669 12.3679V12.21Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuzl);
export default __webpack_public_path__ + "static/media/auzl.d1f90eacbccf962f8b83fe22c7bd7432.svg";
export { ForwardRef as ReactComponent };